import { create } from "zustand";

type SearchBarState = {
  textToSearch: string;
};

export const searchBarTextStateState = create<SearchBarState>(() => ({
  textToSearch: "",
}));

export const updateTextOfSearchTextBar = (text: string) =>
  searchBarTextStateState.setState(() => ({ textToSearch: text }));
